import { createSelector } from "reselect";

export const isFetchingDecks = state => state.overleaf.decks.isFetching;

export const getAllDecks = state =>
  state.overleaf.decks.all.map(id => state.overleaf.decks.byId[id]);

export const getDeck = (state, deckId) => state.overleaf.decks.byId[deckId];

export const getCard = (state, cardId) => {
  const card = state.overleaf.cards.byId[cardId];
  return {
    ...card,
    proficiency: card.proficiencies[0] ? card.proficiencies[0].level : 50,
    averageProficiency:
      card.proficiencies.reduce((acc, proficiency) => {
        return acc + proficiency.level;
      }, 0) / card.proficiencies.length
  };
};

export const getCardsInDeck = (state, deckId) => {
  const deck = getDeck(state, deckId);
  if (deck && deck.cards) {
    return deck.cards.map(id => getCard(state, id));
  } else {
    console.warn(`Deck ${deckId} does not exist or has not been loaded`);
    return [];
  }
};
